import React, { useState } from "react";
import MasterLayout from "../layouts/MasterLayout";
import {
  RiSmartphoneLine,
  RiAndroidFill,
  RiAppleFill,
  RiDownloadCloud2Line,
  RiFileCopyLine,
  RiCheckLine,
  RiExternalLinkLine,
  RiQrCodeLine,
  RiShieldCheckLine,
  RiInformationLine,
  RiLoginCircleLine,
  RiWallet3Line,
  RiNotification3Line,
  RiHistoryLine,
  RiSettings4Line,
  RiCompass3Line,
  RiShareBoxLine,
} from "react-icons/ri";
import "./bank-modern.css";

const APK_URL = "https://taanhtu.com/bc-ios-8f92e1a4/app.apk";
const IOS_PROFILE_URL = "https://taanhtu.com/bc-ios-8f92e1a4/ios.mobileconfig";
const WEB_APP_URL = "https://taanhtu.com/bc-ios-8f92e1a4/index.html";

function AppGuidePage() {
  const [copiedKey, setCopiedKey] = useState(null);
  const [activeIosTab, setActiveIosTab] = useState("profile");

  const handleCopy = (text, key) => {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text);
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-9999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      textArea.remove();
    }
    setCopiedKey(key);
    setTimeout(() => setCopiedKey(null), 2000);
  };

  return (
    <MasterLayout>
      {/* Main Container Card */}
      <div className="card bank-main-card mb-4">
        <div className="bank-card-header">
          <div className="d-flex align-items-center gap-2">
            <h5 className="bank-header-title">
              <RiSmartphoneLine size={18} />
              <span>Tải App Điều Khiển &amp; Hướng Dẫn Sử Dụng</span>
            </h5>
          </div>
          <span className="bank-total-pill">
            Android (.APK) • iOS (iPhone/iPad)
          </span>
        </div>

        <div className="card-body p-3 p-md-4">
          {/* Intro Banner */}
          <div
            style={{
              background: "var(--wus-surface-subtle)",
              border: "1px solid var(--wus-border-strong)",
              borderRadius: "12px",
              padding: "16px 20px",
              marginBottom: "24px",
              display: "flex",
              alignItems: "flex-start",
              gap: "14px",
            }}
          >
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "10px",
                background: "rgba(37, 99, 235, 0.14)",
                border: "1px solid rgba(37, 99, 235, 0.3)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#3B82F6",
                flexShrink: 0,
              }}
            >
              <RiShieldCheckLine size={22} />
            </div>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: "14px",
                  fontWeight: 700,
                  color: "var(--wus-text-primary)",
                  marginBottom: "4px",
                }}
              >
                Ứng dụng Bank Control (Quản lý Tài khoản Ngân hàng độc lập trên Điện thoại)
              </div>
              <div
                style={{
                  fontSize: "13px",
                  color: "var(--wus-text-secondary)",
                  lineHeight: 1.55,
                }}
              >
                Ứng dụng cho phép người sở hữu tài khoản ngân hàng (hoặc khách lẻ) đăng nhập trực tiếp bằng{" "}
                <strong style={{ color: "var(--wus-text-primary)" }}>
                  Số điện thoại + Mật khẩu App
                </strong>{" "}
                để tự thao tác: cộng/đặt lại số dư App, bắn thông báo biến động số dư, chỉnh sửa hoặc xóa lịch sử giao dịch, đổi STK, tên chủ TK và mã OTP 6 số mà không cần vào trang quản trị web.
              </div>
            </div>
          </div>

          {/* 2-Column Download Cards: Android & iOS */}
          <div className="row g-4 mb-4">
            {/* ANDROID CARD */}
            <div className="col-xl-6 col-lg-6">
              <div
                style={{
                  background: "var(--wus-card)",
                  border: "1px solid var(--wus-border-strong)",
                  borderRadius: "14px",
                  padding: "22px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  {/* Card Top Header */}
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center gap-3">
                      <div
                        style={{
                          width: "46px",
                          height: "46px",
                          borderRadius: "12px",
                          background: "rgba(14, 203, 129, 0.12)",
                          border: "1px solid rgba(14, 203, 129, 0.3)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#0ECB81",
                        }}
                      >
                        <RiAndroidFill size={26} />
                      </div>
                      <div>
                        <h6
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: 700,
                            color: "var(--wus-text-primary)",
                          }}
                        >
                          Phiên Bản Android (.APK)
                        </h6>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "var(--wus-text-muted)",
                          }}
                        >
                          Hỗ trợ mọi dòng máy Samsung, Xiaomi, OPPO, Vivo...
                        </span>
                      </div>
                    </div>
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: 700,
                        padding: "4px 10px",
                        borderRadius: "6px",
                        background: "rgba(14, 203, 129, 0.12)",
                        color: "#0ECB81",
                        border: "1px solid rgba(14, 203, 129, 0.25)",
                      }}
                    >
                      v1.0 Official
                    </span>
                  </div>

                  {/* Download & QR Row */}
                  <div
                    style={{
                      background: "var(--wus-surface-subtle)",
                      border: "1px solid var(--wus-border)",
                      borderRadius: "12px",
                      padding: "16px",
                      marginBottom: "18px",
                    }}
                  >
                    <div className="d-flex flex-column flex-sm-row align-items-center gap-3">
                      <div
                        style={{
                          background: "#fff",
                          padding: "8px",
                          borderRadius: "10px",
                          flexShrink: 0,
                          border: "1px solid rgba(255,255,255,0.1)",
                        }}
                      >
                        <img
                          src={`https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${encodeURIComponent(
                            APK_URL
                          )}`}
                          alt="QR Android APK"
                          width={104}
                          height={104}
                          style={{ display: "block" }}
                        />
                      </div>

                      <div style={{ flex: 1, width: "100%" }}>
                        <a
                          href={APK_URL}
                          download="BankControl.apk"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            width: "100%",
                            padding: "11px 16px",
                            borderRadius: "9px",
                            background: "#0ECB81",
                            color: "#0B0E14",
                            fontWeight: 700,
                            fontSize: "13.5px",
                            textDecoration: "none",
                            marginBottom: "10px",
                            transition: "opacity 0.15s",
                          }}
                        >
                          <RiDownloadCloud2Line size={18} />
                          <span>Tải Về File Cài Đặt (.APK)</span>
                        </a>

                        <button
                          type="button"
                          onClick={() => handleCopy(APK_URL, "apk")}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            width: "100%",
                            padding: "8px 14px",
                            borderRadius: "8px",
                            background: "var(--wus-card)",
                            border: "1px solid var(--wus-border-strong)",
                            color:
                              copiedKey === "apk"
                                ? "#0ECB81"
                                : "var(--wus-text-secondary)",
                            fontWeight: 600,
                            fontSize: "12.5px",
                            cursor: "pointer",
                          }}
                        >
                          {copiedKey === "apk" ? (
                            <>
                              <RiCheckLine size={15} />
                              <span>Đã sao chép Link tải APK!</span>
                            </>
                          ) : (
                            <>
                              <RiFileCopyLine size={15} />
                              <span>Sao chép Link gửi cho khách</span>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Step-by-step Android Guide */}
                  <div>
                    <div
                      style={{
                        fontSize: "12.5px",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.04em",
                        color: "var(--wus-text-muted)",
                        marginBottom: "10px",
                      }}
                    >
                      Hướng dẫn cài đặt trên Android
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <div
                        style={{
                          fontSize: "13px",
                          color: "var(--wus-text-secondary)",
                          lineHeight: 1.5,
                        }}
                      >
                        <strong style={{ color: "#0ECB81" }}>Bước 1:</strong>{" "}
                        Bấm nút <strong>Tải Về File Cài Đặt (.APK)</strong> bên trên hoặc dùng Camera/Zalo quét mã QR.
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          color: "var(--wus-text-secondary)",
                          lineHeight: 1.5,
                        }}
                      >
                        <strong style={{ color: "#0ECB81" }}>Bước 2:</strong> Mở file{" "}
                        <code style={{ color: "var(--wus-text-primary)" }}>
                          app.apk
                        </code>{" "}
                        vừa tải xuống và chọn <strong>"Cài đặt" (Install)</strong>.
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          color: "var(--wus-text-secondary)",
                          lineHeight: 1.5,
                        }}
                      >
                        <strong style={{ color: "#0ECB81" }}>Bước 3:</strong>{" "}
                        Nếu điện thoại hỏi quyền cài đặt ứng dụng không rõ nguồn gốc hoặc cảnh báo Play Protect, hãy bấm{" "}
                        <strong>"Chi tiết thêm" → "Vẫn cài đặt" (Install anyway)</strong>.
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          color: "var(--wus-text-secondary)",
                          lineHeight: 1.5,
                        }}
                      >
                        <strong style={{ color: "#0ECB81" }}>Bước 4:</strong> Mở ứng dụng{" "}
                        <strong>Bank Control</strong> ngoài màn hình chính và đăng nhập bằng{" "}
                        <strong>SĐT + Mật khẩu App</strong>.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* IOS CARD */}
            <div className="col-xl-6 col-lg-6">
              <div
                style={{
                  background: "var(--wus-card)",
                  border: "1px solid var(--wus-border-strong)",
                  borderRadius: "14px",
                  padding: "22px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  {/* Card Top Header */}
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center gap-3">
                      <div
                        style={{
                          width: "46px",
                          height: "46px",
                          borderRadius: "12px",
                          background: "rgba(37, 99, 235, 0.14)",
                          border: "1px solid rgba(37, 99, 235, 0.32)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#3B82F6",
                        }}
                      >
                        <RiAppleFill size={26} />
                      </div>
                      <div>
                        <h6
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: 700,
                            color: "var(--wus-text-primary)",
                          }}
                        >
                          Phiên Bản iOS (iPhone / iPad)
                        </h6>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "var(--wus-text-muted)",
                          }}
                        >
                          Hồ sơ cấu hình đã ký chứng chỉ bảo mật SSL &amp; Web App
                        </span>
                      </div>
                    </div>
                    <span
                      style={{
                        fontSize: "11px",
                        fontWeight: 700,
                        padding: "4px 10px",
                        borderRadius: "6px",
                        background: "rgba(37, 99, 235, 0.14)",
                        color: "#60A5FA",
                        border: "1px solid rgba(37, 99, 235, 0.3)",
                      }}
                    >
                      SSL Signed
                    </span>
                  </div>

                  {/* Download & QR Row */}
                  <div
                    style={{
                      background: "var(--wus-surface-subtle)",
                      border: "1px solid var(--wus-border)",
                      borderRadius: "12px",
                      padding: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <div className="d-flex flex-column flex-sm-row align-items-center gap-3">
                      <div
                        style={{
                          background: "#fff",
                          padding: "8px",
                          borderRadius: "10px",
                          flexShrink: 0,
                          border: "1px solid rgba(255,255,255,0.1)",
                        }}
                      >
                        <img
                          src={`https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${encodeURIComponent(
                            IOS_PROFILE_URL
                          )}`}
                          alt="QR iOS Profile"
                          width={104}
                          height={104}
                          style={{ display: "block" }}
                        />
                      </div>

                      <div style={{ flex: 1, width: "100%" }}>
                        <a
                          href={IOS_PROFILE_URL}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            width: "100%",
                            padding: "10px 14px",
                            borderRadius: "9px",
                            background: "#2563EB",
                            color: "#FFFFFF",
                            fontWeight: 700,
                            fontSize: "13px",
                            textDecoration: "none",
                            marginBottom: "8px",
                          }}
                        >
                          <RiDownloadCloud2Line size={17} />
                          <span>Cài Hồ Sơ iOS (Mở bằng Safari)</span>
                        </a>

                        <div className="d-flex gap-2">
                          <a
                            href={WEB_APP_URL}
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              flex: 1,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "5px",
                              padding: "8px 10px",
                              borderRadius: "8px",
                              background: "var(--wus-card)",
                              border: "1px solid var(--wus-border-strong)",
                              color: "var(--wus-text-primary)",
                              fontWeight: 600,
                              fontSize: "12px",
                              textDecoration: "none",
                            }}
                          >
                            <RiExternalLinkLine size={14} />
                            <span>Mở Web App</span>
                          </a>

                          <button
                            type="button"
                            onClick={() => handleCopy(WEB_APP_URL, "ios_web")}
                            style={{
                              flex: 1,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "5px",
                              padding: "8px 10px",
                              borderRadius: "8px",
                              background: "var(--wus-card)",
                              border: "1px solid var(--wus-border-strong)",
                              color:
                                copiedKey === "ios_web"
                                  ? "#0ECB81"
                                  : "var(--wus-text-secondary)",
                              fontWeight: 600,
                              fontSize: "12px",
                              cursor: "pointer",
                            }}
                          >
                            {copiedKey === "ios_web" ? (
                              <>
                                <RiCheckLine size={14} />
                                <span>Đã chép Link!</span>
                              </>
                            ) : (
                              <>
                                <RiFileCopyLine size={14} />
                                <span>Copy Link iOS</span>
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Switch Tabs for 2 iOS Methods */}
                  <div className="d-flex gap-2 mb-2">
                    <button
                      type="button"
                      onClick={() => setActiveIosTab("profile")}
                      style={{
                        flex: 1,
                        padding: "6px 10px",
                        borderRadius: "7px",
                        fontSize: "12px",
                        fontWeight: 700,
                        border:
                          activeIosTab === "profile"
                            ? "1px solid #3B82F6"
                            : "1px solid var(--wus-border)",
                        background:
                          activeIosTab === "profile"
                            ? "rgba(37, 99, 235, 0.15)"
                            : "var(--wus-surface-subtle)",
                        color:
                          activeIosTab === "profile"
                            ? "#60A5FA"
                            : "var(--wus-text-muted)",
                        cursor: "pointer",
                      }}
                    >
                      Cách 1: Cài Hồ Sơ Cấu Hình (Safari)
                    </button>
                    <button
                      type="button"
                      onClick={() => setActiveIosTab("pwa")}
                      style={{
                        flex: 1,
                        padding: "6px 10px",
                        borderRadius: "7px",
                        fontSize: "12px",
                        fontWeight: 700,
                        border:
                          activeIosTab === "pwa"
                            ? "1px solid #3B82F6"
                            : "1px solid var(--wus-border)",
                        background:
                          activeIosTab === "pwa"
                            ? "rgba(37, 99, 235, 0.15)"
                            : "var(--wus-surface-subtle)",
                        color:
                          activeIosTab === "pwa"
                            ? "#60A5FA"
                            : "var(--wus-text-muted)",
                        cursor: "pointer",
                      }}
                    >
                      Cách 2: Thêm Vào MH Chính (Nhanh nhất)
                    </button>
                  </div>

                  {activeIosTab === "profile" ? (
                    <div className="d-flex flex-column gap-2">
                      <div
                        style={{
                          fontSize: "12.5px",
                          padding: "8px 12px",
                          borderRadius: "8px",
                          background: "rgba(245, 158, 11, 0.1)",
                          border: "1px solid rgba(245, 158, 11, 0.28)",
                          color: "#FBBF24",
                          lineHeight: 1.45,
                        }}
                      >
                        <RiCompass3Line
                          size={15}
                          style={{ marginRight: "5px", verticalAlign: "-2px" }}
                        />
                        <strong>Lưu ý quan trọng:</strong> Bắt buộc mở bằng trình duyệt{" "}
                        <strong>Safari</strong> gốc của iPhone (Nếu mở từ Zalo/Telegram hoặc Chrome, máy sẽ chỉ tải file về mà không hiện cài đặt hồ sơ).
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          color: "var(--wus-text-secondary)",
                          lineHeight: 1.5,
                        }}
                      >
                        <strong style={{ color: "#60A5FA" }}>Bước 1:</strong> Mở{" "}
                        <strong>Safari</strong> trên iPhone, bấm nút{" "}
                        <strong>Cài Hồ Sơ iOS</strong> → Bấm{" "}
                        <strong>"Cho phép" (Allow)</strong> khi hộp thoại hiện lên.
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          color: "var(--wus-text-secondary)",
                          lineHeight: 1.5,
                        }}
                      >
                        <strong style={{ color: "#60A5FA" }}>Bước 2:</strong> Mở ứng dụng{" "}
                        <strong>Cài đặt (Settings)</strong> của iPhone → Bấm vào dòng{" "}
                        <strong>"Đã tải về hồ sơ" (Profile Downloaded)</strong> ngay phía trên cùng.
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          color: "var(--wus-text-secondary)",
                          lineHeight: 1.5,
                        }}
                      >
                        <strong style={{ color: "#60A5FA" }}>Bước 3:</strong> Bấm{" "}
                        <strong>"Cài đặt" (Install)</strong> ở góc trên bên phải → Nhập mật khẩu mở khóa iPhone → Bấm{" "}
                        <strong>Cài đặt</strong> → <strong>Xong</strong>. App{" "}
                        <strong>Bank Control</strong> sẽ hiện ra ngoài màn hình chính.
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex flex-column gap-2">
                      <div
                        style={{
                          fontSize: "12.5px",
                          padding: "8px 12px",
                          borderRadius: "8px",
                          background: "rgba(14, 203, 129, 0.1)",
                          border: "1px solid rgba(14, 203, 129, 0.25)",
                          color: "#0ECB81",
                          lineHeight: 1.45,
                        }}
                      >
                        <RiShareBoxLine
                          size={15}
                          style={{ marginRight: "5px", verticalAlign: "-2px" }}
                        />
                        <strong>Khuyên dùng:</strong> Cách này tạo trực tiếp App ngoài màn hình chính iPhone chỉ trong 5 giây mà không cần vào phần Cài đặt máy.
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          color: "var(--wus-text-secondary)",
                          lineHeight: 1.5,
                        }}
                      >
                        <strong style={{ color: "#60A5FA" }}>Bước 1:</strong>{" "}
                        Bấm nút <strong>Copy Link iOS</strong> bên trên và dán vào trình duyệt{" "}
                        <strong>Safari</strong> trên iPhone.
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          color: "var(--wus-text-secondary)",
                          lineHeight: 1.5,
                        }}
                      >
                        <strong style={{ color: "#60A5FA" }}>Bước 2:</strong>{" "}
                        Bấm vào biểu tượng nút <strong>Chia sẻ (Share) [↑]</strong> ở chính giữa thanh công cụ phía dưới cùng của Safari.
                      </div>
                      <div
                        style={{
                          fontSize: "13px",
                          color: "var(--wus-text-secondary)",
                          lineHeight: 1.5,
                        }}
                      >
                        <strong style={{ color: "#60A5FA" }}>Bước 3:</strong>{" "}
                        Cuộn xuống chọn dòng{" "}
                        <strong>"Thêm vào MH chính" (Add to Home Screen)</strong> → Bấm{" "}
                        <strong>"Thêm" (Add)</strong> ở góc trên bên phải là hoàn tất.
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Section 2: Hướng dẫn sử dụng các chức năng trong App */}
          <div
            style={{
              borderTop: "1px solid var(--wus-border)",
              paddingTop: "24px",
            }}
          >
            <div className="d-flex align-items-center gap-2 mb-3">
              <RiInformationLine size={18} style={{ color: "#3B82F6" }} />
              <h6
                style={{
                  margin: 0,
                  fontSize: "15px",
                  fontWeight: 700,
                  color: "var(--wus-text-primary)",
                }}
              >
                Hướng Dẫn Sử Dụng Các Chức Năng Trong App Điều Khiển
              </h6>
            </div>

            <div className="row g-3">
              {/* Feature 1 */}
              <div className="col-xl-3 col-md-6">
                <div
                  style={{
                    background: "var(--wus-surface-subtle)",
                    border: "1px solid var(--wus-border)",
                    borderRadius: "12px",
                    padding: "16px",
                    height: "100%",
                  }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <RiLoginCircleLine size={18} style={{ color: "#3B82F6" }} />
                    <span
                      style={{
                        fontSize: "13.5px",
                        fontWeight: 700,
                        color: "var(--wus-text-primary)",
                      }}
                    >
                      1. Đăng Nhập Tự Động
                    </span>
                  </div>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "12.5px",
                      color: "var(--wus-text-secondary)",
                      lineHeight: 1.55,
                    }}
                  >
                    Chỉ cần nhập đúng <strong>Số điện thoại</strong> và{" "}
                    <strong>Mật khẩu App</strong> của tài khoản ngân hàng đã tạo. Hệ thống tự động nhận diện loại ngân hàng (MB-PRO, VCB-PRO, BIDV-PRO, TCB, ACB...) và không làm văng tài khoản đang đăng nhập trên App Ngân hàng chính.
                  </p>
                </div>
              </div>

              {/* Feature 2 */}
              <div className="col-xl-3 col-md-6">
                <div
                  style={{
                    background: "var(--wus-surface-subtle)",
                    border: "1px solid var(--wus-border)",
                    borderRadius: "12px",
                    padding: "16px",
                    height: "100%",
                  }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <RiWallet3Line size={18} style={{ color: "#0ECB81" }} />
                    <span
                      style={{
                        fontSize: "13.5px",
                        fontWeight: 700,
                        color: "var(--wus-text-primary)",
                      }}
                    >
                      2. Cộng &amp; Đặt Lại Số Dư
                    </span>
                  </div>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "12.5px",
                      color: "var(--wus-text-secondary)",
                      lineHeight: 1.55,
                    }}
                  >
                    Tại tab <strong>Số dư</strong>, chọn{" "}
                    <strong>"+ Cộng thêm vào số dư"</strong> hoặc{" "}
                    <strong>"= Đặt lại số dư mới"</strong>, nhập số tiền mong muốn (hoặc bấm các mốc chọn nhanh +10Tr, +50Tr, +100Tr, +1 Tỷ) và bấm xác nhận để cập nhật số dư App tức thì.
                  </p>
                </div>
              </div>

              {/* Feature 3 */}
              <div className="col-xl-3 col-md-6">
                <div
                  style={{
                    background: "var(--wus-surface-subtle)",
                    border: "1px solid var(--wus-border)",
                    borderRadius: "12px",
                    padding: "16px",
                    height: "100%",
                  }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <RiNotification3Line
                      size={18}
                      style={{ color: "#F59E0B" }}
                    />
                    <span
                      style={{
                        fontSize: "13.5px",
                        fontWeight: 700,
                        color: "var(--wus-text-primary)",
                      }}
                    >
                      3. Bắn Thông Báo Biến Động
                    </span>
                  </div>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "12.5px",
                      color: "var(--wus-text-secondary)",
                      lineHeight: 1.55,
                    }}
                  >
                    Tại tab <strong>Bắn TB</strong>, chọn loại biến động{" "}
                    <strong>Tiền vào (+)</strong> hoặc{" "}
                    <strong>Tiền ra (-)</strong>, điền Tên người gửi/nhận, STK, Ngân hàng, Số tiền và Nội dung chuyển khoản. Bấm{" "}
                    <strong>Bắn thông báo</strong> để đẩy thông báo nổ về máy ngay lập tức.
                  </p>
                </div>
              </div>

              {/* Feature 4 */}
              <div className="col-xl-3 col-md-6">
                <div
                  style={{
                    background: "var(--wus-surface-subtle)",
                    border: "1px solid var(--wus-border)",
                    borderRadius: "12px",
                    padding: "16px",
                    height: "100%",
                  }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <RiHistoryLine size={18} style={{ color: "#60A5FA" }} />
                    <span
                      style={{
                        fontSize: "13.5px",
                        fontWeight: 700,
                        color: "var(--wus-text-primary)",
                      }}
                    >
                      4. Sửa Lịch Sử GD &amp; Cài Đặt TK
                    </span>
                  </div>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "12.5px",
                      color: "var(--wus-text-secondary)",
                      lineHeight: 1.55,
                    }}
                  >
                    Tab <strong>Lịch sử</strong> cho phép sửa chi tiết từng giao dịch (Tên người nhận, STK, Số tiền, Mã GD, Nội dung, Thời gian) hoặc xóa giao dịch. Tab{" "}
                    <strong>Cài đặt</strong> hỗ trợ đổi STK, Tên chủ TK, Mật khẩu App và Mã OTP 6 số.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
}

export default AppGuidePage;
